import script from "./QuizResultBar.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizResultBar.vue?vue&type=script&setup=true&lang=js"

import "./QuizResultBar.vue?vue&type=style&index=0&id=35508290&scoped=true&lang=css"

import exportComponent from "/builds/kmkn5581/messequiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35508290"]])

export default __exports__